import type { ReactElement } from 'react'

import * as styles from './modal-split-layout.styles'

type Props = {
  start: ReactElement
  end: ReactElement
}

export const ModalSplitLayout = ({ start, end }: Props) => (
  <div css={styles.root} data-testid="modal-split-layout">
    <section>{start}</section>
    <section css={styles.endSection}>{end}</section>
  </div>
)
